// Shared bits for useInfiniteQuery-based paged lists.

// "Short page = stop": if the server returned fewer rows than the page size,
// we're done. More robust than asking a separate count endpoint, since the
// count and list endpoints can drift out of sync.
export const makeGetNextPageParam = (pageSize) => (lastPage) =>
	lastPage.rows.length < pageSize ? undefined : lastPage.pageParam + 1;

// Removes a row from every cached page so an optimistic delete preserves the
// user's scroll position. Pair with a count invalidation if the header shows
// a total.
export const removeRowFromInfiniteCache = (queryClient, queryKey, predicate) => {
	queryClient.setQueryData(queryKey, (old) => {
		if (!old?.pages) return old;
		return {
			...old,
			pages: old.pages.map((page) => ({
				...page,
				rows: page.rows.filter((row) => !predicate(row)),
			})),
		};
	});
};

// Flatten useInfiniteQuery's paged data into a single rows array.
export const flattenPages = (queryData) =>
	queryData?.pages?.flatMap((p) => p.rows) ?? [];
